import { TableCell } from '@material-ui/core'
import { Loader } from 'components/Shared/Loader'
import React from 'react'
import { useSummaryRowStyles } from './styles'
import { FinancialCell } from './FinancialCell'
import { CurrencyCell } from './CurrencyCell'

export function FinancialSummaryContent ({ financialSummary }) {
  const classes = useSummaryRowStyles()

  if (!financialSummary) {
    return <TableCell className={classes.tableLoaderCell}>
      <Loader/>
    </TableCell>
  }

  const { margin, priceSummaryPLN, priceSummaryEUR } = financialSummary

  return <div>
    <FinancialCell label={'orderTable.summaryRow.margin'} amount={margin} symbol={'%'}/>
    <CurrencyCell currency={'PLN'}/>
    <FinancialCell label={'orderTable.summaryRow.income'}
                   amount={priceSummaryPLN.customerPrice.amount}/>
    <FinancialCell label={'orderTable.summaryRow.cost'}
                   amount={priceSummaryPLN.carrierPrice.amount}/>
    <FinancialCell label={'orderTable.summaryRow.profit'}
                   amount={priceSummaryPLN.profit.amount}/>

    <CurrencyCell currency={'EUR'}/>
    <FinancialCell label={'orderTable.summaryRow.income'}
                   amount={priceSummaryEUR.customerPrice.amount}/>
    <FinancialCell label={'orderTable.summaryRow.cost'}
                   amount={priceSummaryEUR.carrierPrice.amount}/>
    <FinancialCell label={'orderTable.summaryRow.profit'}
                   amount={priceSummaryEUR.profit.amount}/>
  </div>
}
